import { toast } from 'react-toastify';

/**
 * Admin Logout Utility
 * Handles logout functionality with confirmation and cleanup
 */

export const adminLogout = (options = {}) => {
  const {
    showConfirmation = true,
    redirect = true,
    showToast = true,
    clearAll = false
  } = options;

  const performLogout = () => {
    try {
      // Clear admin-specific storage
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      
      // Clear all storage if requested (for complete cleanup)
      if (clearAll) {
        localStorage.clear();
        localStorage.clear();
      }
      
      // Dispatch storage event to sync logout across tabs
      window.dispatchEvent(new StorageEvent('storage', {
        key: 'admin_logout',
        newValue: Date.now().toString()
      }));
      
      // Show success message
      if (showToast) {
        toast.success('Logged out successfully');
      }
      
      // Redirect to login page
      if (redirect) {
        // Small delay to show toast before redirect
        setTimeout(() => {
          window.location.href = '/hpanel/login';
        }, 500);
      }
      
      return true;
    } catch (error) {
      console.error('Logout error:', error);
      toast.error('Failed to logout. Please try again.');
      return false;
    }
  };

  // Show confirmation dialog if enabled
  if (showConfirmation) {
    const confirmed = window.confirm('Are you sure you want to logout?');
    if (!confirmed) {
      return false;
    }
  }

  return performLogout();
};

/**
 * Force logout without confirmation (for 401 errors, token expiration, etc.)
 */
export const forceAdminLogout = () => {
  return adminLogout({
    showConfirmation: false,
    showToast: false,
    clearAll: true
  });
};

/**
 * Check if admin is logged in (for conditional rendering)
 */
export const isAdminLoggedIn = () => {
  try {
    const token = localStorage.getItem('admin_token');
    const user = localStorage.getItem('admin_user');
    return !!(token && user);
  } catch (error) {
    return false;
  }
};

/**
 * Get admin user data
 */
export const getAdminUser = () => {
  try {
    const userStr = localStorage.getItem('admin_user');
    return userStr ? JSON.parse(userStr) : null;
  } catch (error) {
    return null;
  }
};

export default {
  logout: adminLogout,
  forceLogout: forceAdminLogout,
  isLoggedIn: isAdminLoggedIn,
  getUser: getAdminUser
};